import React from "react";
import Header from "../components/header/Header";
import Nav from "../components/nav/Nav";
import About from "../components/about/About";
import Services from "../components/services/Services";
import Portfolio from "../components/portfolio/Portfolio";
import Experience from "../components/experience/Expreience";
import Testimonials from "../components/testimonials/Testimonials";
const Home = ({ data, allVideos }) => {
  return (
    <div>
      <Header intro={data.intro} />
      <About about={data.about} />
      <Services services={data.servicesSection} allVideos={allVideos} />
      <Nav />
      {/* <Experience /> */}
      {/* <Portfolio recentWorks={data.recentWorks} /> */}
      <Testimonials test={data.testimonials} />
    </div>
  );
};

export default Home;
